<template>
    <div id="vehicle-edit-view" class="view form-view">

        <div class="form-box">
            <h2>Create vehicle</h2>
        </div>

        <vehicle-create-from :fleet-uuid="this.$route.params.fleetUuid"></vehicle-create-from>
    </div>
</template>

<script>
import VehicleCreateFrom from './components/VehicleCreateFrom'

export default {
    name: 'VehicleCreate',
    components: { VehicleCreateFrom }
}
</script>

<style scoped>

</style>
